/* eslint-enable */
/* eslint-enable */

class AnimationTwoColsImageText {
	
	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleTwoColsImageText = this.sectionsContainer.querySelectorAll('.two-cols-image-text');
		
		if (!this.$moduleTwoColsImageText)
			return;
		
		this.$moduleTwoColsImageTextElements = []
		this.$moduleTwoColsImageText.forEach(module => {
			this.$moduleTwoColsImageTextElements.push(module.querySelectorAll('.anima'));	
		});
		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleTwoColsImageText.forEach((module, index) => {
			gsap.set(module, { opacity: 1 });
	        gsap.set(this.$moduleTwoColsImageTextElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });	
		});
	}

	initAnimate(index) {
		const moduleTwoColsImageText = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleTwoColsImageText[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleTwoColsImageTextElements[index], { clearProps: true });
			}
        });
    
        moduleTwoColsImageText.addLabel('step1');
        moduleTwoColsImageText.to(this.$moduleTwoColsImageText[index], { opacity: 1, duration: 1 }, 'step1');
		moduleTwoColsImageText.to(this.$moduleTwoColsImageTextElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default AnimationTwoColsImageText;